import { ContentSwitcher, Switch } from 'carbon-components-react';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from 'src/apps/maas360-estimator/locales/messages';

type switcherProps = {
  setPackageOption: React.Dispatch<React.SetStateAction<string>>;
  packageOption: string;
  topMatch: string;
  deluxePkg: boolean;
  setDeluxePkg: React.Dispatch<React.SetStateAction<boolean>>;
  handleSegmentTracking: (cta: string) => void;
};

const Switcher = ({
  setPackageOption,
  topMatch,
  deluxePkg,
  setDeluxePkg,
  handleSegmentTracking,
}: switcherProps) => {
  const intl = useIntl();
  const topMatchText =
    topMatch === 'Essentials'
      ? intl.formatMessage(messages.essentials)
      : topMatch === 'Enterprise'
      ? intl.formatMessage(messages.enterprise)
      : intl.formatMessage(messages.premier);
  return (
    <div>
      <ContentSwitcher
        className="content-switcher"
        selectedIndex={deluxePkg ? 1 : 0}
        size="md"
        onChange={(obj) => {
          const { name, text } = obj;
          setDeluxePkg(name === 'Deluxe' ? true : false);
          setPackageOption(text == undefined ? '' : name + '');
          handleSegmentTracking('Plan option tile');
        }}
      >
        <Switch name={topMatch} text={topMatchText} />
        <Switch name="Deluxe" text={intl.formatMessage(messages.deluxe)} />
      </ContentSwitcher>
    </div>
  );
};

export default Switcher;
